import { userStore } from "../store";

export const removeNotification = (id: string) => {
  const index = userStore.user.toast_notifications.findIndex((toast) => toast.id === id);
  if (index > -1) {
    userStore.user.toast_notifications.splice(index, 1);
  }
};
